export const GraphicDataModel = {
	NONE:      'none',
	EVENT:     'event',
	EVENT_TAG: 'event_tag',
};
